// extracted by mini-css-extract-plugin
export var messageSideLeft = "_q7-1";
export var stateContainer = "_q7-0";